import { FC } from 'react'
import { StyleHeading } from './style'
import theme from '@utils/theme'
interface SectionHeadingProps {
  title: string
  tc?: keyof typeof theme.colors
}
const SectionHeading: FC<SectionHeadingProps> = ({ title, tc = 'text500' }) => {
  return <StyleHeading tc={tc}>{title}</StyleHeading>
}

export default SectionHeading
